module.exports = __webpack_public_path__ + "static/img/13.d811b7f4.jpg";